import {validatenull} from './validate'
export const initMenu = (router, menu) => {
  if (menu.length === 0) {
    return
  }
  router.addRoutes(formatRoutes(menu))
}

export const formatRoutes = (aMenu) => {

  let aRouter = []
  aMenu.forEach(oMenu => {
    let {
      path,
      component,
      name,
      icon,
      children
    } = oMenu
    if (!validatenull(component)) {
      const oRouter = {
        path: path,
        component(resolve) {
          let componentPath = ''
          if (component === 'Layout') {
            require(['@/page/index'], resolve)
            return
          } else if (component === 'PARENT_MENU') {
            return
          } else {
            componentPath = component
          }
          require([`@/${componentPath}.vue`], resolve)
        },
        name: name,
        icon: icon,
        children: validatenull(children) ? [] : formatRoutes(children)
      }
      aRouter.push(oRouter)
    }
  })
  return aRouter
}

/**
 * 加密处理
 */
export const encryption = (params) => {
  let {
    data,
    type,
    param,
    key
  } = params
  const result = JSON.parse(JSON.stringify(data))
  if (type === 'Base64') {
    param.forEach(ele => {
      result[ele] = btoa(result[ele])
    })
  } else {
    param.forEach(ele => {
      var data = result[ele]
      key = CryptoJS.enc.Latin1.parse(key)
      var iv = key
      // 加密
      var encrypted = CryptoJS.AES.encrypt(
        data,
        key,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.ZeroPadding
        })
      result[ele] = encrypted.toString()
    })
  }
  return result
}


/**
 * 设置浏览器头部标题
 */
export const setTitle = function (title) {
  // title = title ? `${title}——极致互联微服务开发平台` : '极致互联微服务开发平台'
  window.document.title = title
}
/**
 * 浏览器判断是否全屏
 */
export const fullscreenToggel = () => {
  if (fullscreenEnable()) {
    exitFullScreen()
  } else {
    reqFullScreen()
  }
}
/**
 * esc监听全屏
 */
export const listenfullscreen = (callback) => {
  function listen() {
    callback()
  }

  document.addEventListener('fullscreenchange', function (e) {
    listen()
  })
  document.addEventListener('mozfullscreenchange', function (e) {
    listen()
  })
  document.addEventListener('webkitfullscreenchange', function (e) {
    listen()
  })
  document.addEventListener('msfullscreenchange', function (e) {
    listen()
  })
}

/**
 * 浏览器判断是否全屏
 */
export const fullscreenEnable = () => {
  var isFullscreen = document.fullscreenEnabled ||
    window.fullScreen ||
    document.mozFullscreenEnabled ||
    document.webkitIsFullScreen
  return isFullscreen
}

/**
 * 浏览器全屏
 */
export const reqFullScreen = () => {
  if (document.documentElement.requestFullScreen) {
    document.documentElement.requestFullScreen()
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.documentElement.webkitRequestFullScreen()
  } else if (document.documentElement.mozRequestFullScreen) {
    document.documentElement.mozRequestFullScreen()
  }
}

/**
 * 浏览器退出全屏
 */
export const exitFullScreen = () => {
  if (document.documentElement.requestFullScreen) {
    document.exitFullScreen()
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.webkitCancelFullScreen()
  } else if (document.documentElement.mozRequestFullScreen) {
    document.mozCancelFullScreen()
  }
}

/**
 * 递归寻找子类的父类
 */
export const findParent = (menu, id) => {
  for (let i = 0; i < menu.length; i++) {
    if (menu[i].children.length !== 0) {
      for (let j = 0; j < menu[i].children.length; j++) {
        if (menu[i].children[j].id === id) {
          return menu[i]
        } else {
          if (menu[i].children[j].children.length !== 0) {
            return findParent(menu[i].children[j].children, id)
          }
        }
      }
    }
  }
}

/**
 * 递归为菜单路径赋值
 */

export const addPath = (ele) => {
  ele.children.forEach(child => {
    const isChild = ele.children.length !== 0;
    if (isChild) {
      if (!child.path.includes('http') && !child.path.includes('https')) {
        child.path = `${ele.path}/${child.path?child.path:'index'}`
      }
      addPath(child);
    }
  })
}

export const formatPath = (menu) => {
  if (Array.isArray(menu)) {
    for (let i = 0; i < menu.length; i++) {
      if (menu[i].children.length !== 0) {
        var ele = menu[i]
        for (let j = 0; j < ele.children.length; j++) {
          let child = ele.children[j]
          if (!validatenull(child.component)) child.path = `${ele.path}/${child.path}`
          if (child.children.length === 0) {
            continue
          } else if (child.children.length !== 0) {
            formatPath(child)
          }
        }
      }
    }
  } else {
    var ele = menu
    for (let j = 0; j < ele.children.length; j++) {
      let child = ele.children[j]
      if (!validatenull(child.component)) child.path = `${ele.path}/${child.path}`
      if (child.children.length === 0) {
        continue
      } else if (child.children.length !== 0) {
        formatPath(child)
      }
    }
  }
  return menu
}
/**
 * 递归为菜单路径赋值
 */
export const formatSelectTree = (treeData) => {
  if (Array.isArray(treeData)) {
    for (let i = 0; i < treeData.length; i++) {
      if (treeData[i].children.length !== 0) {
        let ele = treeData[i]
        for (let j = 0; j < ele.children.length; j++) {
          let child = ele.children[j]
          if (child.children.length === 0) {
              child.children = undefined
            continue
          } else if (child.children.length !== 0) {
            formatSelectTree(child)
          }
        }
      }
    }
  } else {
    let ele = treeData
    for (let j = 0; j < ele.children.length; j++) {
      let child = ele.children[j]
      if (child.children.length === 0) {
        child.children = undefined
        continue
      } else if (child.children.length !== 0) {
        formatSelectTree(child)
      }
    }
  }
  return treeData
}

/**
 * 总体路由处理器
 */
export const resolveUrlPath = (url, name) => {
  let reqUrl = url
  if (url.indexOf('#') !== -1 && url.indexOf('http') === -1) {
    const port = reqUrl.substr(reqUrl.indexOf(':'))
    reqUrl = `/appIframe/urlPath?src=${baseUrl}${port}${reqUrl.replace('#', '').replace(port, '')}}&name=${name}`
  } else if (url.indexOf('http') !== -1) {
    reqUrl = `/appIframe/urlPath?src=${reqUrl}&name=${name}`
  } else {
    reqUrl = `${reqUrl}`
  }
  return reqUrl
}

/**
 * 总体路由设置器
 */
export const setUrlPath = ($route) => {
  let value = ''
  if ($route.query.src) {
    value = $route.query.src
  } else {
    value = $route.path
  }
  return value
}

/**
 * 动态插入css
 */
export const loadStyle = url => {
  const link = document.createElement('link')
  link.type = 'text/css'
  link.rel = 'stylesheet'
  link.href = url
  const head = document.getElementsByTagName('head')[0]
  head.appendChild(link)
}

/**
 * 根据字典的value显示label
 */
export const findByvalue = (dic, value) => {
  let result = ''
  if (validatenull(dic)) return value
  if (typeof (value) === 'string' || typeof (value) === 'number') {
    let index = 0
    index = findArray(dic, value)
    if (index !== -1) {
      result = dic[index].label
    } else {
      result = value
    }
  } else if (value instanceof Array) {
    result = []
    let index = 0
    value.forEach(ele => {
      index = findArray(dic, ele)
      if (index !== -1) {
        result.push(dic[index].label)
      } else {
        result.push(value)
      }
    })
    result = result.toString()
  }
  return result
}

/**
 * 根据字典的value查找对应的index
 */
export const findArray = (dic, value) => {
  for (let i = 0; i < dic.length; i++) {
    if (dic[i].value === value) {
      return i
    }
  }
  return -1
}

/**
 * 生成随机len位数字
 */
export const randomLenNum = (len, date) => {
  let random = ''
  random = Math.ceil(Math.random() * 100000000000000).toString().substr(0, typeof len === 'number' ? len : 4)
  if (date) random = random + Date.now()
  return random
}

 //处理为空数据
 export const  dealElement =(obj) =>{
  var param = {};
  if ( obj === null || obj === undefined || obj === "" ) return param;
  for ( var key in obj ){
      if ( obj[key] !== null && obj[key] !== undefined && obj[key] !== "" ){
          param[key] = obj[key];
      }
  }
  console.log("清理数据信息");
  return param;
}

// 校验手机号是否合法
 export const checkPhone=(phone)=> {
  if(!phone) {
    return false
  }
  if (phone.trim().length != 11 || !/^1[3|4|5|6|7|8|9]\d{9}$/.test(phone)) {
    return false
  }
  return true
}

// 根据文件名后缀区分 文件类型
 export const matchType = (fileName)=> {
    // 后缀获取
    var suffix = '';
    // 获取类型结果
    var result = '';
    try {
      var flieArr = fileName.split('.');
      suffix = flieArr[flieArr.length - 1];
    } catch (err) {
      suffix = '';
    }
    // fileName无后缀返回 false
    if (!suffix) {
      result = false;
      return result;
    }
    // 图片格式
    var imglist = [ 'jpg', 'jpeg', 'bmp','JPG', 'JPEG', 'BMP'];
    // 进行图片匹配
    result = imglist.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'jpg';
      return result;
    };

    // 图片格式
    var imglistPng = ['png','PNG'];
    // 进行图片匹配
    result = imglistPng.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'png';
      return result;
    };
    // 图片格式
    var imglistGif = ['gif','GIF'];
    // 进行图片匹配
    result = imglistGif.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'gif';
      return result;
    };
    // 匹配txt
    var txtlist = ['txt'];
    result = txtlist.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'txt';
      return result;
    };
    // 匹配 excel
    var excelist = ['xls', 'xlsx'];
    result = excelist.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'excel';
      return result;
    };
    // 匹配 word
    var wordlist = ['doc', 'docx'];
    result = wordlist.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'word';
      return result;
    };
    // 匹配 pdf
    var pdflist = ['pdf'];
    result = pdflist.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'pdf';
      return result;
    };
    // 匹配 ppt
    var pptlist = ['ppt'];
    result = pptlist.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'ppt';
      return result;
    };
    // 匹配 视频
    var videolist = ['mp4', 'm2v', 'mkv'];
    result = videolist.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'video';
      return result;
    };
    // 匹配 音频
    var radiolist = ['mp3', 'wav', 'wmv'];
    result = radiolist.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'radio';
      return result;
    }
    // 其他 文件类型
    result = 'other';
    return result;
  };

  // 金额 不要四舍五入 改为取小数点后2位 直接截取 2020.8.13
  export const toFixed2=(num)=>{
    if(num){
      let _num=num.toString()
      let p= _num.indexOf('.')
      if(p>0){
        return _num.slice(0,p+3)
      }else{
        return _num;
      }
    }else{
      return 0
    }
  }


export const twoDecimalFull=(num)=> {
  var result = parseFloat(num);
  if (isNaN(result)) {
    return '-';
  }
  result = Math.round(num * 100) / 100;
  var s_x = result.toString();
  var pos_decimal = s_x.indexOf('.');
  if (pos_decimal < 0) {
    pos_decimal = s_x.length;
    s_x += '.';
  }
  while (s_x.length <= pos_decimal + 2) {
    s_x += '0';
  }
  return s_x;
}
